




















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import Contract from '@/domain/contract/entity/contract.entity';
import EnumObject from '@/domain/enum-object.entity';
import FeeItemRule from '@/domain/contract/entity/fee-item-rule.entity';
import ContractService from '@/domain/contract/service/contract.service';
import FeeItemRuleRequest from '@/domain/contract/request/fee-item-rule-request.entity';
import ContractFee from '@/domain/contract/request/contract-fee.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import EditModeButton from '../fees-and-discounts-commons/edit-mode-button.component.vue';
import StrategyRadio from '../fees-and-discounts-commons/strategy-radio.component.vue';
import FeeStrategies from './fee-strategy.json';
import FeeTypes from './fee-type.json';
import FeeDiscountTypeSelect from '../fees-and-discounts-commons/fee-discount-type-select.component.vue';
import FeeDiscountCompetences from '../fees-and-discounts-commons/fee-discount-competences.component.vue';
import FeeDiscountTable from '../fees-and-discounts-commons/fee-discount-table.component.vue';

@Component({
  components: {
    EditModeButton,
    FeeDiscountTypeSelect,
    StrategyRadio,
    FeeDiscountCompetences,
    FeeDiscountTable,
    MainButton,
  },
})
export default class FeeComponent extends Vue {
  @Prop({
    required: true,
  })
  contract!: Contract;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  isEditable!: boolean;

  @Prop({ type: Boolean, default: false }) isAdministratorOrSupervisorOrGp!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() isSupervisor!: boolean;

  editModeValue: boolean = false;

  feeStrategies: EnumObject[] = EnumObject.ofList(FeeStrategies);

  feeTypes: EnumObject[] = EnumObject.ofList(FeeTypes);

  rules: FeeItemRule[] = [...this.contract.currentVersion!!.feeItemRules];

  setEditMode(value: boolean): void {
    this.editModeValue = value;
  }

  setFeeStrategy(feeStrategy: string): void {
    const strategy = FeeStrategies.find((it) => it.value === feeStrategy);
    this.contract.feeStrategy = EnumObject.of(strategy);
    this.applyFeeFlagValueOnRules();
  }

  setFeeType(value: string): void {
    const feeType = FeeTypes.find((it) => it.value === value);
    this.contract.feeType = EnumObject.of(feeType);
  }

  setPeriodStart(value: string): void {
    this.contract.feePeriodStart = value;
  }

  setPeriodEnd(value: string): void {
    this.contract.feePeriodEnd = value;
  }

  setRuleSelection({ value, index }: any): void {
    this.rules[index].applyFee = value;
  }

  setFeeValue({ value, index }: any): void {
    this.rules[index].fee = value;
  }

  applyFeeFlagValueOnRules(): void {
    if (this.contract.feeStrategy.value === 'APPLY_ALL') {
      this.rules.forEach((rule) => rule.applyFee = true);
      this.changeValue(this.rules[0].fee);
    }

    if (this.contract.feeStrategy.value === 'NOT_APPLY') {
      this.rules.forEach((rule) => rule.applyFee = false);
      this.applyFeeValueForAllRules(0);
      this.rerenderTextFields();
    }
  }

  changeValue(value: any): void {
    if (this.contract.feeStrategy.value === 'APPLY_ALL') {
      this.applyFeeValueForAllRules(value);
    }
    this.rerenderTextFields();
  }

  applyFeeValueForAllRules(value: any): void {
    this.rules.forEach((rule) => rule.fee = value);
  }

  get isSelectionDisabled(): boolean {
    return !this.editModeValue
      || this.contract.notApplyFeeStrategy
      || this.contract.applyAllFeeStrategy;
  }

  rerenderTextFields(): void {
    const { feeTable }: any = this.$refs;
    feeTable.rerenderTextFields();
  }

  validate(): boolean {
    const { form }: any = this.$refs;
    return form.validate();
  }

  clickSave(): void {
    if (this.validate()) {
      this.persistFee();
    }
  }

  persistFee(): void {
    const rules: FeeItemRuleRequest[] = FeeItemRuleRequest.ofList(this.rules);
    rules.forEach((it) => it.feeType = this.contract.feeType.value);
    const contractFee: ContractFee = ContractFee.of({
      feeStrategy: this.contract.feeStrategy.value,
      feeType: this.contract.feeType.value,
      periodStart: this.contract.feePeriodStart,
      periodEnd: this.contract.feePeriodEnd,
      rules,
    });
    ContractService
      .saveFeeConfig(this.businessUnitId, this.contract.id, contractFee)
      .then(() => {
        VbSnackbarService.showSuccess('Acréscimo(s) salvo(s) com sucesso');
        this.editModeValue = false;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  cancel(): void {
    this.editModeValue = false;
  }
}
